// key = language, value = url
export const HelpLink: {[key: string]: string} = {
    de: './res/help/de_faq.html#showmenu',
    en: './res/help/en_faq.html#showmenu',
    es: './res/help/es_faq.html#showmenu',
    fr: './res/help/fr_faq.html#showmenu',
    it: './res/help/it_faq.html#showmenu',
    nl: './res/help/nl_faq.html#showmenu',
    pl: './res/help/pl_faq.html#showmenu',
    pt: './res/help/pt_faq.html#showmenu',
    ro: './res/help/ro_faq.html#showmenu',
    tr: './res/help/tr_faq.html#showmenu',
};
export const HelpIframeLink: {[key: string]: string} = {
    de: './res/help_mobile/de_faq.html',
    en: './res/help_mobile/en_faq.html',
    es: './res/help_mobile/es_faq.html',
    fr: './res/help_mobile/fr_faq.html',
    it: './res/help_mobile/it_faq.html',
    nl: './res/help_mobile/nl_faq.html',
    pl: './res/help_mobile/pl_faq.html',
    pt: './res/help_mobile/pt_faq.html',
    ro: './res/help_mobile/ro_faq.html',
    tr: './res/help_mobile/tr_faq.html',
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/LinkConstants.ts